angular.module('elfium').controller('businessCaseListItemController', ['$scope', 'taskGetNearestFilter', 'taskSplitByTypeFilter', 'taskService', 'reportService', 'businessCaseService', 'businessCaseStateFilter', 'businessCaseLastStageFilter', 'TASK_TYPES', 'TASK_STATES', 'BUSINESS_CASE_STATES',
    function ($scope, taskGetNearestFilter, taskSplitByTypeFilter, taskService, reportService, businessCaseService, businessCaseStateFilter, businessCaseLastStageFilter, TASK_TYPES, TASK_STATES, BUSINESS_CASE_STATES) {
        var that = this;
        that.reloadBusinessCase = function () {
            $scope.$emit('reloadBusinessCase', $scope.businessCaseListItem.id);
        };
        that.isStateWin = function () {
            return $scope.businessCaseListItem.stav === BUSINESS_CASE_STATES.WIN;
        };
        that.isStateLost = function () {
            return $scope.businessCaseListItem.stav === BUSINESS_CASE_STATES.LOST;
        };
        that.isStateActive = function () {
            return $scope.businessCaseListItem.stav === BUSINESS_CASE_STATES.ACTIVE;
        };
        that.getBusinessCaseStateFromReports = function () {
            reportService.getReportsByBusinessCaseId($scope.businessCaseListItem.id).then(function (reportsByTypes) {
                $scope.businessCaseListItem.stav = businessCaseStateFilter(reportsByTypes);
                var lastStage = businessCaseLastStageFilter(reportsByTypes);
                if (!angular.equals($scope.businessCaseListItem.lastStage, lastStage)) {
                    $scope.businessCaseListItem.lastStage = lastStage;
                }
            });
        };
        $scope.isTaskOpen = function (task) {
            return task.stav === TASK_STATES.NAPLANOVANO;
        };
        $scope.isTaskFailed = function (task) {
            return task.stav === TASK_STATES.NESPLNENO;
        };
        $scope.isTaskSucceeded = function (task) {
            return task.stav === TASK_STATES.SPLNENO;
        };
        $scope.getLostButtonClass = function () {
            return that.isStateLost() ? 'btn-link' : 'btn-primary';
        };
        $scope.canLoseBusinessCase = function () {
            return !that.isStateWin();
        };
        $scope.getKOtevreniTasks = function () {
            return $scope.tasksByType[TASK_TYPES.KOTEVRENI];
        };
        $scope.getPotrebaTasks = function () {
            return $scope.tasksByType[TASK_TYPES.POTREBA];
        };
        $scope.getNabidkaTasks = function () {
            return $scope.tasksByType[TASK_TYPES.NABIDKA];
        };
        $scope.getKUzavreniTasks = function () {
            return $scope.tasksByType[TASK_TYPES.KUZAVRENI];
        };
        $scope.addTask = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            taskService.newTaskForBusinessCaseDetailModal($scope.businessCaseListItem.id).then(that.reloadBusinessCase);
        };
        $scope.openBusinessCaseDetailModal = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            businessCaseService.openBusinessCaseDetailModal($scope.businessCaseListItem.id).then(that.reloadBusinessCase);
        };
        $scope.setBusinessCaseWin = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            if ($scope.canWinBusinessCase()) {
                businessCaseService.setBusinessCaseState($scope.businessCaseListItem.id, BUSINESS_CASE_STATES.WIN).then(that.reloadBusinessCase);
            }
        };
        $scope.setBusinessCaseLost = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            if ($scope.canLoseBusinessCase()) {
                businessCaseService.setBusinessCaseState($scope.businessCaseListItem.id, BUSINESS_CASE_STATES.LOST).then(that.reloadBusinessCase);
            }
        };
        $scope.setBusinessCaseUnidentified = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            if ($scope.canSetUnidentified()) {
                businessCaseService.setBusinessCaseState($scope.businessCaseListItem.id, BUSINESS_CASE_STATES.UNIDENTIFIED).then(that.reloadBusinessCase);
            }
        };
        $scope.$watchCollection('businessCaseListItem', function () {
            $scope.tasksByType = taskSplitByTypeFilter($scope.businessCaseListItem.tasks);
            $scope.nearestTask = taskGetNearestFilter($scope.businessCaseListItem.tasks);
            if (!$scope.businessCaseListItem.stav) {
                that.getBusinessCaseStateFromReports();
            }
        });
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseListItemController.ts